export default [
  {
    path: '/mobile',
    name: 'mobile-home',
    component: () => import('@/views/mobile/main/Home.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '首页',
    },
  },
  {
    path: '/mobile/file-view/attachment/:id',
    name: 'mobile-file-view-attachment',
    component: () => import('@/views/empty/file-view/AttachmentView.vue'), // 该组件同时适用于移动端和非移动端多套路由地址
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '文件预览',
    },
  },
  {
    path: '/mobile/my-service-list',
    name: 'mobile-my-service-list',
    component: () =>
      import('@/views/admin/main/components/service/MyServiceList.vue'), // 该组件同时适用于移动端和非移动端多套路由地址
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '服务中心',
    },
  },
];
